import { httpRequest } from "../../http";

export class CommandGetOrganization {
    async run(organizationId: string) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/`
       
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return response;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

  
}



